module.exports = __webpack_public_path__ + "static/4-da5765812b6449f0fdfd7df70d6487f9.png";